import { call, put } from 'redux-saga/effects';
import FirmwareActions from '../redux/FirmwareRedux';
import MessagesActions from '../redux/MessagesRedux';

export function* getFirmware(api, action) {
  const response = yield call(api.getFirmware, action.id);

  if (response.ok) {
    yield put(FirmwareActions.firmwareSuccess(response.data));
  } else {
    yield put(
      FirmwareActions.firmwareFailure(
        response.data && response.data.title ? response.data.title : response.problem,
      ),
    );
    yield put(
      MessagesActions.messagesShow({
        type: 'error',
        code: response.status,
        title: response.data && response.data.title ? response.data.title : response.problem,
      }),
    );
  }
}

export function* getFirmwareComments(api, action) {
  const response = yield call(api.getFirmwareComments, action.id);

  if (response.ok) {
    yield put(FirmwareActions.firmwareCommentSuccess(response.data));
  } else {
    yield put(
      FirmwareActions.firmwareCommentFailure(
        response.data && response.data.title ? response.data.title : response.problem,
      ),
    );
    yield put(
      MessagesActions.messagesShow({
        type: 'error',
        code: response.status,
        title: response.data && response.data.title ? response.data.title : response.problem,
      }),
    );
  }
}

export function* addFirmwareComments(api, action) {
  const response = yield call(api.addFirmwareComments, action.id, action.data);

  if (response.ok) {
    const getResponse = yield call(api.getFirmwareComments, action.id);
    yield put(FirmwareActions.firmwareCommentSuccess(getResponse.data));
    yield put(
      MessagesActions.messagesShow({
        type: 'success',
        code: 'firmwareCommentAdd',
        title: 'Комментарий успешно добавлен',
      }),
    );
  } else {
    yield put(
      FirmwareActions.firmwareCommentFailure(
        response.data && response.data.title ? response.data.title : response.problem,
      ),
    );
    yield put(
      MessagesActions.messagesShow({
        type: 'error',
        code: response.status,
        title: response.data && response.data.title ? response.data.title : response.problem,
      }),
    );
  }
}

export function* addFirmware(api, action) {
  const response = yield call(api.addFirmware, action.data);

  if (response.ok) {
    yield put(FirmwareActions.firmwareSuccess(response.data));
    yield put(
      MessagesActions.messagesShow({
        type: 'success',
        code: 'firmwareAdd',
        title: 'Запись успешно создана',
      }),
    );
  } else {
    yield put(
      FirmwareActions.firmwareFailure(
        response.data && response.data.title ? response.data.title : response.problem,
      ),
    );
    yield put(
      MessagesActions.messagesShow({
        type: 'error',
        code: response.status,
        title: response.data && response.data.title ? response.data.title : response.problem,
        text: response.data?.title || response.problem,
      }),
    );
  }
}

export function* addFirmwareFile(api, action) {
  const { id, formData } = action;
  const response = yield call(api.addFirmwareFile, id, formData);

  if (response.ok) {
    yield put(
      MessagesActions.messagesShow({
        type: 'success',
        code: 'firmwareFileAdd',
        title: 'Файл успешно загружен',
      }),
    );
  } else {
    yield put(
      MessagesActions.messagesShow({
        type: 'error',
        code: response.status,
        title: response.data && response.data.title ? response.data.title : response.problem,
      }),
    );
  }
}

export function* downloadFirmwareFile(api, action) {
  const response = yield call(api.getFirmwareFile, action.id);

  if (response.ok) {
    const contentType =
      response.headers && response.headers['content-type']
        ? response.headers['content-type']
        : 'application/octet-stream';
    const blob = response.data instanceof Blob ? response.data : new Blob([response.data], { type: contentType });

    const downloadUrl = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = downloadUrl;

    const contentDisposition = response.headers ? response.headers['content-disposition'] : null;
    const filenameFromHeader = sanitizeFilename(getFilenameFromContentDisposition(contentDisposition));
    const filenameFromUi = sanitizeFilename(action.fileName);
    const filename = filenameFromUi || filenameFromHeader || `firmware_${action.id}.bin`;

    link.setAttribute('download', filename);

    document.body.appendChild(link);
    link.click();
    link.remove();

    setTimeout(() => window.URL.revokeObjectURL(downloadUrl), 1000);

    yield put(FirmwareActions.firmwareFileDownloadSuccess(downloadUrl));
  } else {
    yield put(FirmwareActions.firmwareFileDownloadFailure(response.problem));
  }
}

export function* updateFirmware(api, action) {
  const response = yield call(api.editFirmware, action.data);
  const newFirmware = yield call(api.getFirmware, action.data.id);

  if (response.ok) {
    yield put(FirmwareActions.firmwareSuccess(newFirmware.data));
    yield put(
      MessagesActions.messagesShow({
        type: 'success',
        code: 'firmwareUpdate',
        title: 'Запись успешно обновлена',
      }),
    );
  } else {
    yield put(
      FirmwareActions.firmwareFailure(
        response.data && response.data.title ? response.data.title : response.problem,
      ),
    );
    yield put(
      MessagesActions.messagesShow({
        type: 'error',
        code: response.status,
        title: 'Обновление не удалось',
        text: response.data?.title || response.problem,
      }),
    );
  }
}

export function* deleteFirmware(api, action) {
  const response = yield call(api.deleteFirmware, action.id);

  if (response.ok) {
    yield put(FirmwareActions.firmwareSuccess(null));
    yield put(
      MessagesActions.messagesShow({
        type: 'success',
        code: 'firmwareDelete',
        title: 'Запись успешно удалена',
      }),
    );
  } else {
    yield put(
      FirmwareActions.firmwareFailure(
        response.data && response.data.title ? response.data.title : response.problem,
      ),
    );
    yield put(
      MessagesActions.messagesShow({
        type: 'error',
        code: response.status,
        title: response.data && response.data.title ? response.data.title : response.problem,
        text: response.data?.title || response.problem,
      }),
    );
  }
}

export function* updateFirmwareWithFile(api, action) {
  const { data, file } = action;

  const firmwareResponse = yield call(api.editFirmware, data);

  if (firmwareResponse.ok) {
    if (file) {
      const uploadResponse = yield call(api.addFirmwareFile, data.id, file);

      if (!uploadResponse.ok) {
        yield put(
          MessagesActions.messagesShow({
            type: 'error',
            code: uploadResponse.status,
            title:
              uploadResponse.data && uploadResponse.data.title
                ? uploadResponse.data.title
                : uploadResponse.problem,
            text: uploadResponse.data?.title || uploadResponse.problem,
          }),
        );
        return;
      }
    }

    const updatedFirmwareResponse = yield call(api.getFirmware, data.id);

    if (updatedFirmwareResponse.ok) {
      yield put(FirmwareActions.firmwareSuccess(updatedFirmwareResponse.data));
      yield put(
        MessagesActions.messagesShow({
          type: 'success',
          code: 'firmwareUpdateSuccess',
          title: 'Прошивка успешно обновлена',
        }),
      );
    } else {
      yield put(
        MessagesActions.messagesShow({
          type: 'error',
          code: updatedFirmwareResponse.status,
          title:
            updatedFirmwareResponse.data && updatedFirmwareResponse.data.title
              ? updatedFirmwareResponse.data.title
              : updatedFirmwareResponse.problem,
          text: updatedFirmwareResponse.data?.title || updatedFirmwareResponse.problem,
        }),
      );
    }
  } else {
    yield put(FirmwareActions.firmwareFailure(firmwareResponse.data.title || firmwareResponse.problem));
    yield put(
      MessagesActions.messagesShow({
        type: 'error',
        code: firmwareResponse.status,
        title:
          firmwareResponse.data && firmwareResponse.data.title
            ? firmwareResponse.data.title
            : firmwareResponse.problem,
        text: firmwareResponse.data?.title || firmwareResponse.problem,
      }),
    );
  }
}

function getFilenameFromContentDisposition(contentDisposition) {
  if (!contentDisposition) return null;

  // Prefer RFC 5987/6266: filename*=UTF-8''...
  const filenameStarMatch = contentDisposition.match(/filename\*\s*=\s*([^;]+)/i);
  if (filenameStarMatch && filenameStarMatch[1]) {
    const value = filenameStarMatch[1].trim();
    const parts = value.split("''");
    const encoded = parts.length === 2 ? parts[1] : value;
    try {
      return decodeURIComponent(encoded.replace(/(^['"]|['"]$)/g, ''));
    } catch (e) {
      return encoded.replace(/(^['"]|['"]$)/g, '');
    }
  }

  const filenameMatch = contentDisposition.match(/filename\s*=\s*([^;]+)/i);
  if (filenameMatch && filenameMatch[1]) {
    return filenameMatch[1].trim().replace(/(^['"]|['"]$)/g, '');
  }

  return null;
}

function sanitizeFilename(fileName) {
  if (!fileName || typeof fileName !== 'string') return null;
  const trimmed = fileName.trim().replace(/(^['"]|['"]$)/g, '');
  if (!trimmed) return null;

  return trimmed.replace(/[\\/:*?"<>|]+/g, '_');
}
